import { fetchQuery, type Environment } from 'relay-runtime';
import { OrderHistoryViewerQuery as OrdersViewerQueryNode } from '@/features/order/graphql/OrderHistoryViewerQuery';
import RestaurantOrdersPageViewerQueryNode from '@/__generated__/RestaurantOrdersPageViewerQuery.graphql';

const preload = (environment: Environment, query: any, variables: Record<string, unknown>) => {
  return fetchQuery(environment, query, variables).toPromise();
};

export const preloadViewer = (environment: Environment) => {
  return preload(environment, OrdersViewerQueryNode, {});
};

export const preloadRestaurantDashboard = async (environment: Environment) => {
  await preload(environment, RestaurantOrdersPageViewerQueryNode, {});
};
